import React from 'react';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import {Grid, IconButton} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {useDialog} from "../../../../hooks/useDialog";
import LibraryDialog from "../../../../containers/LibraryDialog/LibraryDialog.jsx";


const useStyles = makeStyles(() => (
        {
            selectButton: {
                color: '#0A8100',
                border: '1px solid #0A8100',
                width: '150px',
                padding: '3px 3px'
            },
            selectButtonLabel: {
                fontSize: '0.5rem',
                fontWeight: 500,
                lineHeight: 1.57,
                letterSpacing: '0.00714em',
                display: 'inline'
            }
        }
    )
)

const SelectButton = ({onClick}) => {
    const classes = useStyles()
    return <Button onClick={onClick} variant="outlined" size='small'
                   classes={{outlined: classes.selectButton}}>
        <Typography variant={'subtitle2'} classes={{subtitle2: classes.selectButtonLabel}}>
            выбрать нарушение
        </Typography>
    </Button>
}

const ClearButton = ({onClick}) => <IconButton onClick={onClick} size='small'>
    <CloseIcon/>
</IconButton>


export const NormativeArticleSelect = ({
                                           label,
                                           value,
                                           setFieldValue,
                                           touched,
                                           error,
                                           helperText,
                                           content,
                                           name,
                                           disabled
                                       }) => {
    const {open, handleOpen, handleClose} = useDialog()

    const onCommitOffense = (offense) => {
        setFieldValue(name, {
            id: offense.id,
            value: offense.reference,
            shortText: offense.short_text
        })
    }

    const onClearButton = () => {
        setFieldValue(name, null)
    }

    return <>
        <TextField id="offense"
                   label={label}
                   value={value?.value || ''}
                   error={touched && Boolean(error)}
                   helperText={error && touched ? error : helperText}
                   InputProps={{
                       endAdornment: !disabled ? value ?
                           <Grid item container justifyContent={'flex-end'} alignItems={'center'}>
                               <Grid item>
                                   <ClearButton onClick={onClearButton}/>
                               </Grid>
                               <Grid item>
                                   <SelectButton onClick={handleOpen}/>
                               </Grid>
                           </Grid> : <SelectButton onClick={handleOpen}/> : null,
                       readOnly: true,
                   }}
                   size={'small'}
                   variant={'outlined'}
                   inputProps={{"aria-disabled": true}}
                   fullWidth
        />
        {!disabled ?
            <LibraryDialog
                open={open}
                shadow={content?.shadow || true}
                onCommitNormativeArticle={onCommitOffense}
                onClose={handleClose}
            />
            : null}
    </>
}